import { DateTime } from "luxon";

export const getDeadlineDate = (date: string): Date =>
  DateTime.fromISO(date, { zone: "Europe/Berlin" }).endOf("day").toJSDate();
export const formatDeadlineDate = (deadline: Date): string =>
  deadline.toLocaleDateString("de-DE", {
    timeZone: "Europe/Berlin",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
